import { Reducer } from 'react';
import { CartItem } from '../../Interfaces/Cart';

// Type constants
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const INCREASE_QUANTITY = 'INCREASE_QUANTITY';
export const DECREASE_QUANTITY = 'DECREASE_QUANTITY';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const CLEAR_CART = 'CLEAR_CART';

export interface StateInterface {
  id: string,
  userId: string,
  cartItems: CartItem[],
}

// interfaces
interface ActionInterface {
  type: string,
  payload: any,
}
type CartItemIndex = number;

// Actions
const addProduct = (state: StateInterface, payload: CartItem) => {
  const isAlreadyAdded = state.cartItems
    .findIndex(({ product }) => product.id === payload.product.id);
  if (isAlreadyAdded > -1) return state;
  return { ...state, cartItems: [...state.cartItems, payload] };
};

const addQuantity = (state: StateInterface, payload: CartItemIndex) => {
  const newCartItems = [...state.cartItems];
  newCartItems[payload] = {
    ...newCartItems[payload],
    quantity: newCartItems[payload].quantity + 1,
  };
  return { ...state, cartItems: [...newCartItems] };
};

const deductQuantity = (state: StateInterface, payload: CartItemIndex) => {
  const newCartItems = [...state.cartItems];
  if (newCartItems[payload].quantity > 1) {
    newCartItems[payload] = {
      ...newCartItems[payload],
      quantity: newCartItems[payload].quantity - 1,
    };
  }
  return { ...state, cartItems: [...newCartItems] };
};

const removeProduct = (state: StateInterface, payload: CartItemIndex) => {
  let newCartItems = [...state.cartItems];
  newCartItems = newCartItems
    .filter((cartItem) => cartItem.product.id !== newCartItems[payload].product.id);
  return { ...state, cartItems: [...newCartItems] };
};

const clearCart = (state: StateInterface) => ({ ...state, cartItems: [] });

// Cart Reducer
const CartReducer: Reducer<StateInterface, ActionInterface> = (state, { type, payload }) => {
  switch (type) {
    case ADD_PRODUCT:
      return addProduct(state, payload);
    case INCREASE_QUANTITY:
      return addQuantity(state, payload);
    case DECREASE_QUANTITY:
      return deductQuantity(state, payload);
    case REMOVE_CART_ITEM:
      return removeProduct(state, payload);
    case CLEAR_CART:
      return clearCart(state);
    default:
      return state;
  }
};

export default CartReducer;
